import React from 'react';
import './TeamMembers.css'; // Ensure this path is correct
import teamMember1 from "../assets/imgs/team-mate-img-1.png"
import teamMember2 from "../assets/imgs/team-mate-img-2.png"
import teamMember1Skl1 from "../assets/imgs/member-1-skl-1.png"
import teamMember1Skl2 from "../assets/imgs/member-1-skl-2.png"
import teamMember1Skl3 from "../assets/imgs/member-1-skl-3.png"
import teamMember1Skl4 from "../assets/imgs/member-1-skl-4.png"
import teamMember1Skl5 from "../assets/imgs/member-1-skl-5.png"




const TeamMembers = () => {
    return (

            <section className="team-mates">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-xl-3 col-sm-12 col-md-12 team-mate-img ">
                            <div className="team-mate-img-backg">
                                <img src={teamMember1} alt="Team Member" height="500" width="280" className="team-mate-img-1"/>
                            </div>
                            <p className="d-flex justify-content-center align-items-center mt-2 text-white"><b>Steffi Allysa</b></p>
                            <p className="d-flex justify-content-center align-items-center mb-4 text-white">Chief Creative Officer</p>
                        </div>

                        <div className="col-lg-9 col-xl-9 col-sm-12 col-md-12 team-skills">
                            <div className="d-flex justify-content-start align-items-center text-center">
                                <div className="skill-box"><p className="skill-word">SKILLS</p></div>
                                <div style={{ width: '30%', height: '0%', border: '2px solid #E1B8AB' }}></div>
                                <div className="mr-4 ml-4"><h2>5.0</h2></div>
                                <div className="star d-flex justify-content-center align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#cca314" className="bi bi-star-fill" viewBox="0 0 16 16">
                                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                     </svg>
                                </div>
                            </div>
                            <div className="team-member-skill-logs d-flex justify-content-evenly align-items-center  ">
                                <img src={teamMember1Skl1} alt="skill 1" className="logos-skill" />
                                <img src={teamMember1Skl2} alt="skill 2" className="logos-skill" />
                                <img src={teamMember1Skl3} alt="skill 3" className="logos-skill"/>
                                <img src={teamMember1Skl4} alt="skill 4" className="logos-skill"/>
                                <img src={teamMember1Skl5} alt="skill 5" className="logos-skill"/>
                            </div>
                            <div className="team-member-skill-logs-name d-flex justify-content-evenly  text-center  ">
                                <p className=" logo-name ">Figma</p>
                                <p className="logo-name ">Adobe<br/>Photoshop</p>
                                <p className="logo-name  ">Adobe<br/> illustrator</p>
                                <p className="logo-name  ">Adobe<br/>  Xd</p>
                                <p className="logo-name ">Adobe<br/> indesign</p>
                            </div>
                            <div className="team-member-1-detail">
                                <p className="team-member-1-detail-p">Cras eu dignissim mauris. Duis imperdiet erat sapien, molestie aliquet arcu tincidunt id. Mauris sit amet quam mi. Duis porttitor lectus quis turpis malesuada, eu luctus elit dignissim.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row sec-row">
                        <div className="col-lg-9 col-xl-9 col-sm-12 col-md-12 team-skills">
                            <div className="d-flex justify-content-end align-items-center text-center">
                                <div className="star d-flex justify-content-center align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#cca314" className="bi bi-star-fill" viewBox="0 0 16 16">
                                         <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                    </svg>
                                </div>
                                <div className="rating-num"><h2>5.0</h2></div>
                                      <div style={{ width: '30%', height: '0%', border: '2px solid #E1B8AB', }}></div>
                                <div className="skill-box-2"><p className="skill-word">SKILLS</p></div>

                            </div>
                            <div className="team-member-skill-logs d-flex justify-content-evenly align-items-center  ">
                                <img src={teamMember1Skl1} alt="skill 1" className="logos-skill" />
                                <img src={teamMember1Skl2} alt="skill 2" className="logos-skill" />
                                <img src={teamMember1Skl3} alt="skill 3" className="logos-skill"/>
                                <img src={teamMember1Skl4} alt="skill 4" className="logos-skill"/>
                                <img src={teamMember1Skl5} alt="skill 5" className="logos-skill"/>


                            </div>
                            <div className="team-member-skill-logs-name d-flex justify-content-evenly  text-center  ">
                                <p className=" logo-name ">Figma</p>
                                <p className="logo-name ">Adobe<br/>Photoshop</p>
                                <p className="logo-name  ">Adobe<br/> illustrator</p>
                                <p className="logo-name  ">Adobe<br/>  Xd</p>
                                <p className="logo-name ">Adobe<br/> indesign</p>
                            </div>
                            <div className="team-member-1-detail">
                                <p className="team-member-1-detail-p">Cras eu dignissim mauris. Duis imperdiet erat sapien, molestie aliquet arcu tincidunt id. Mauris sit amet quam mi. Duis porttitor lectus quis turpis malesuada, eu luctus elit dignissim.</p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-xl-3 col-sm-12 col-md-12 team-mate-img ">
                            <div class="team-mate-img-backg">
                                <img src={teamMember2} alt="Team Member" height="500" width="272" class="team-mate-img-1"/>
                            </div>
                            <p class="d-flex justify-content-center align-items-center mt-2 text-white"><b>Steffi Allysa</b></p>
                            <p class="d-flex justify-content-center align-items-center mb-4 text-white">Chief Creative Officer</p>
                        </div>
                    </div>

                    <div className="row last-team-member">
                        <div className="col-lg-3 col-xl-3 col-sm-12 col-md-12 team-mate-img ">
                            <div className="team-mate-img-backg">
                                <img src={teamMember1} alt="Team Member" height="500" width="280" className="team-mate-img-1"/>
                            </div>
                            <p className="d-flex justify-content-center align-items-center mt-2 text-white"><b>Steffi Allysa</b></p>
                            <p className="d-flex justify-content-center align-items-center mb-4 text-white">Chief Creative Officer</p>
                        </div>

                        <div className="col-lg-9 col-xl-9 col-sm-12 col-md-12 team-skills">
                            <div className="d-flex justify-content-start align-items-center text-center">
                                <div className="skill-box"><p className="skill-word">SKILLS</p></div>
                                <div style={{ width: '30%', height: '0%', border: '2px solid #E1B8AB' }}></div>
                                <div className=" mr-4 ml-4"><h2>5.0</h2></div>
                                <div className="star d-flex justify-content-center align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#cca314" className="bi bi-star-fill" viewBox="0 0 16 16">
                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                    </svg>
                                </div>
                            </div>
                            <div className="team-member-skill-logs d-flex justify-content-evenly align-items-center  ">
                                <img src={teamMember1Skl1} alt="skill 1" className="logos-skill" />
                                <img src={teamMember1Skl2} alt="skill 2" className="logos-skill" />
                                <img src={teamMember1Skl3} alt="skill 3" className="logos-skill"/>
                                <img src={teamMember1Skl4} alt="skill 4" className="logos-skill"/>
                                <img src={teamMember1Skl5} alt="skill 5" className="logos-skill"/>


                            </div>
                            <div className="team-member-skill-logs-name d-flex justify-content-evenly  text-center  ">
                                <p className=" logo-name ">Figma</p>
                                <p class="logo-name ">Adobe<br/>Photoshop</p>
                                <p class="logo-name  ">Adobe<br/> illustrator</p>
                                <p class="logo-name  ">Adobe<br/>  Xd</p>
                                <p class="logo-name ">Adobe<br/> indesign</p>
                            </div>
                            <div class="team-member-1-detail">
                                <p class="team-member-1-detail-p">Cras eu dignissim mauris. Duis imperdiet erat sapien, molestie aliquet arcu tincidunt id. Mauris sit amet quam mi. Duis porttitor lectus quis turpis malesuada, eu luctus elit dignissim.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

    );
};

export default TeamMembers;
